//* 组件库工具函数引入
import { utility } from "various-ui";

//* i18n配置
import { i18nOption } from "@/app/i18n";

//* 类型引入
import type { ApiOption } from "./types";

//* 参数处理函数
export default (option?: ApiOption): ApiOption => {
    //* 获取route
    const route = useRoute();

    //* 初始化参数
    const result = {
        //* 请求的数据, 常用于POST | PUT 等类型的接口
        body: option?.body,
        //* 请求的数据, 常用于GET | DELETE 等类型的接口
        query: option?.query,
        //* 请求的数据, 常用于动态接口
        params: option?.params,
        //* 请求中止的关联信号
        signal: option?.signal,
        //* 请求头
        headers: (option?.headers as any) || {},
        //* 长连接
        keepalive: option?.keepalive,
        //* 响应类型
        responseType: option?.responseType,

        //* 请求的模式, cors | no-cors | same-origin, 用于确定是否跨域的参数
        mode: option?.mode,
        /**
         * * 请求的缓存模式
         * * 1. default: 浏览器从HTTP缓存中寻找匹配资源, 如果存在缓存但过期, 会发起请求判断是更新还是替换, 反之则下载并缓存资源
         * * 2. no-store: 浏览器从远程服务器获取资源, 不查看缓存, 不更新缓存
         * * 3. reload: 浏览器从远程服务器获取资源, 不查看缓存, 但更新缓存
         * * 4. no-cache: 浏览器从HTTP缓存中寻找匹配资源, 如果存在缓存, 会发起请求判断是更新还是替换, 反之则下载并缓存资源
         * * 5. force-cache: 浏览器从HTTP缓存中寻找匹配资源, 如果存在缓存直接返回, 反之则下载并缓存资源
         * * 6. only-if--cached: 浏览器从HTTP缓存中寻找匹配资源, 如果存在缓存直接返回, 反之则返回一个错误
         */
        cache: option?.cache,
        //* 请求的类型, 常用类型有: GET | POST | PUT | DELETE | PATCH
        method: option?.method || "GET",

        //* 请求失败后自动重试的次数
        retry: option?.retry || false,
        //* 路由前缀
        baseURL: option?.baseURL,

        //* 请求拦截器
        onRequest: option?.onRequest,
        onResponse: option?.onResponse,
        onRequestError: option?.onRequestError,
        onResponseError: option?.onResponseError,
    };

    //* 设置Api语言类型
    result.headers["x-language"] = route?.meta?.routeLanguage || i18nOption.locale;

    //* 根据Method进行数据处理
    const method = result.method.toLocaleUpperCase();
    if (["GET"].includes(method)) {
        result.query = option?.data;
    } else if (["PUT", "POST", "PATCH", "DELETE"].includes(method)) {
        result.body = option?.data;
    }

    return utility.objectPick(result, (data) => data != undefined);
};
